import React from 'react';
import { Outlet } from 'react-router-dom';
import '../assets/styles/Layout.css'; // import your CSS
import Navbar from '../components/company/Navbar';
import Footer from '../components/company/Footer';

const CompanyLayout = () => {
  return (
    <div className="d-flex flex-column h-100">
      {/* Navbar - 8vh */}
      {/* Main Content - 86vh */}
      <main className="main-content-area flex-grow-1">
        <Outlet />
      </main>   

      {/* Footer - 6vh */}
      <div className="footer text-dark">
        <Footer/>
      </div>
    </div>
  );
};

export default CompanyLayout;   
